export default {
	COMUM: {
		GET_INFO_CABECALHO: 'getInfoCabecalho',
		GET_PARAMETRO_SISTEMA: 'getParametroSistema',
		GET_CAMUNDA_PROCESS_KEY: 'getCamundaProcessKey',
		GET_ORGAO_LOGADO: 'getOrgaoLogado',
		GET_CURRENT_TASK: 'getCurrentTask',
		GET_STATUS_INSTANCE: 'getStatusInstance',
	},
	ATA: {
		GET_INFORMACOES_ATA: 'informacoesAta',
		GET_ATA_PARA_CABECALHO: 'getAtaParaCabecalho',
		GET_TEM_PERMISSAO_EDICAO: 'getTemPermissaoEdicao',
		GET_USUARIO_PODE_VISUALIZAR_ACOMPANHAMENTO: 'getUsuarioPodeVisualizarAcompanhamento',
		GET_PODE_VER_ADESOES_DO_ADERENTE: 'getPodeVerAdesoesDoAderente',
		GET_POSSUI_ADESOES_PARA_ANALISE_DO_GESTOR: 'getPossuiAdesoesParaAnaliseDoGestor',
		GET_SITUACAO_DA_ATA: 'getSituacaoDaAta',
		GET_IS_ATA_ADESAO: 'getIsAtaAdesao',
		GET_POSSUI_DOCUMENTO_TIPO_ATA_REGISTRO_PRECO: 'getPossuiDocumentoTipoAtaRegistroPreco',
		GET_POSSUI_DOCUMENTO_TIPO_ATA_REGISTRO_PRECO_SEM_CONCLUIR_EDICAO:
			'getPossuiDocumentoTipoAtaRegistroPrecoSemConcluirEdicao',
		GET_POSSUI_DOCUMENTO_TIPO_ATA_REGISTRO_PRECO_NAO_ASSINADO: 'getPossuiDocumentoTipoAtaRegistroPrecoNaoAssinado',
		GET_IS_ENVIADA_PNCP: 'getEnviadaPncp',
		GET_URL_PNCP: 'getUrlPncp',
		GET_IS_MIGRACAO: 'getIsMigracao',
		ABAS_INTERNAS_DA_ATA: 'abasInternasDaAta',
		GESTAO_PEDIDOS: {
			ABAS_INTERNAS_GESTAO_PEDIDOS: 'abasInternasGestaoPedidos',
		},
	},
	ADESAO: {
		GET_ABAS_ADESAO: 'getAbasAdesao',
	},
	PEDIDO: {
		GET_INFORMACOES: 'informacoesPedido',
		GET_PEDIDO_PARA_CABECALHO: 'getPedidoParaCabecalho',
		GET_ABAS_PEDIDO: 'getAbasPedido',
		GET_HAS_AUTHORITY_FLUXO: 'getHasAuthorityFluxo',
		GET_ETAPA_NOME: 'getEtapaNome',
		GET_ETAPA_SITUACAO: 'getEtapaSituacao',
		IS_PEDIDO_RASCUNHO: 'isPedidoRascunho',
		GET_ORGAO_PEDIDO: 'getOrgaoPedido',
		GET_REVISAO_PEDIDO: 'getRevisaoPedido',
	},
	ITEM_PEDIDO: {
		ESTORNO: {
			ESTORNAR: {
				QUANTIDADE_ESTORNADA: 'informacoesPedido',
			},
		},
	},
	ITEM_ATA: {
		ITENS_SELECIONADOS_COUNT: 'itensSelecionadosCount',
		IS_TEM_ITEM_SELECIONADO: 'isTemSelecionado',
		IS_SELECIONADO: 'isSelecionado',
		ITENS_PARA_INSERIR_NA_ATA: 'itensParaInserirNaAta',
		ITENS_PARA_EXCLUIR: 'itensParaExcluir',
		IS_NAO_ADICIONADO: 'isNaoAdicionado',
		ALTERAR_CLASSIFICACAO: {
			ALTERAR: {
				DADOS_ALTERAR: 'dadosAlterar',
			},
		},
		EXISTE_TODOS_HISTORICOS_ITEM: 'existeTodosHistoricosItemAta',
		EXISTE_HISTORICO_REALINHAMENTO: 'existeHistoricoRealinhamentoItemAta',
		EXISTE_HISTORICO_BLOQUEIO: 'existeHistoricoBloqueioItemAta',
		EXISTE_HISTORICO_ALTERAR_CLASSIFICACAO: 'existeHistoricoAlterarClassificacaoItemAta',
		EXISTE_HISTORICO_ALTERAR_FORNECEDOR: 'existeHistoricoAlterarFornecedorItemAta',
		EXISTE_HISTORICO_GERENCIAR_SALDO: 'existeHistoricoGerenciarSaldoItemAta',
	},
	OCORRENCIA: {
		GET_INFORMACOES_OCORRENCIA: 'getInformacoesOcorrencia',
		GET_INFORMACOES_ITENS_OCORRENCIA: 'getInformacoesItensOcorrencia',
	},
}
